module.exports = {
      id: "gallery-scope-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#gallery-scope",
      toString: function () {
        return this.url;
      }
    }